var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3381 6.5375C24.3256 6.3375 22.3131 6.1875 20.2881 6.075V6.0625L20.0131 4.4375C19.8256 3.2875 19.5506 1.5625 16.6256 1.5625H13.3506C10.4381 1.5625 10.1631 3.2125 9.96306 4.425L9.70056 6.025C8.53806 6.1 7.37556 6.175 6.21306 6.2875L3.66306 6.5375C3.13806 6.5875 2.76306 7.05 2.81306 7.5625C2.86306 8.075 3.31306 8.45 3.83806 8.4L6.38806 8.15C12.9381 7.5 19.5381 7.75 26.1631 8.4125C26.2006 8.4125 26.2256 8.4125 26.2631 8.4125C26.7381 8.4125 27.1506 8.05 27.2006 7.5625C27.2381 7.05 26.8631 6.5875 26.3381 6.5375Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M24.0377 10.175C23.7377 9.8625 23.3252 9.6875 22.9002 9.6875H7.10018C6.67518 9.6875 6.25018 9.8625 5.96268 10.175C5.67518 10.4875 5.51268 10.9125 5.53768 11.35L6.31268 24.175C6.45018 26.075 6.62518 28.45 10.9877 28.45H19.0127C23.3752 28.45 23.5502 26.0875 23.6877 24.175L24.4627 11.3625C24.4877 10.9125 24.3252 10.4875 24.0377 10.175Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9766 21.25C11.9766 20.7322 12.3963 20.3125 12.9141 20.3125H17.0766C17.5943 20.3125 18.0141 20.7322 18.0141 21.25C18.0141 21.7678 17.5943 22.1875 17.0766 22.1875H12.9141C12.3963 22.1875 11.9766 21.7678 11.9766 21.25Z",
    fill: "#FB4764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9375 16.25C10.9375 15.7322 11.3572 15.3125 11.875 15.3125H18.125C18.6428 15.3125 19.0625 15.7322 19.0625 16.25C19.0625 16.7678 18.6428 17.1875 18.125 17.1875H11.875C11.3572 17.1875 10.9375 16.7678 10.9375 16.25Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashPurple);
export default __webpack_public_path__ + "static/media/trash-purple.d198621102b97ead5250aa18281f5c21.svg";
export { ForwardRef as ReactComponent };